import { render, staticRenderFns } from "./AdmisionHabilitadosAptitudGral.vue?vue&type=template&id=2391c856"
import script from "./AdmisionHabilitadosAptitudGral.vue?vue&type=script&lang=js"
export * from "./AdmisionHabilitadosAptitudGral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports